import { FeedbackStatus, FeedbackSubmitterType } from '~/types';

// env config
export const API_CONFIG = {
    API_HOST: process.env.REACT_APP_API_HOST,
    API_ID: process.env.REACT_APP_API_APP_ID,
    API_TIME_OUT: parseInt(process.env.REACT_APP_API_TIMEOUT || '0'),
};

// keys for localstorage
export const STORAGE_KEY = {
    SIDEBAR_STATE: 'sidebar-state',
    // Collapsed state of the embedded sidebar drawer. Mirrors the host's
    // `adminSidebar` redux slice, which it also persists, so the member's choice
    // survives route changes and reloads of the iframe.
    EMBEDDED_SIDEBAR_COLLAPSED: 'embedded-sidebar-collapsed',
};

// WEBFONT config
export const WEBFONT_CONFIG = {
    google: {
        families: [
            'Poppins:300',
            'Poppins:400',
            'Poppins:500',
            'Poppins:600',
            'Poppins:700',
            'Poppins:800',
            'Poppins:900',
        ],
    },
};

export const colorBrandActive = '#0069e6';
export const colorBrandGreen = '#25b862';

// services
export const services = {
    oAuthService: 'oauth2-service/',
    userService: 'user-service',
    authenticationService: '/authentication-service',
    coreService: '/core-service',
    databaseService: '/database-service',
    messageService: '/message-service',
    welfareService: '/welfare-service',
};

export const RegionTypes = ['Country', 'Postcode'];

export const providerTypes = [
    'Charity',
    'Not-For-Profit',
    'Local Authority',
    'Company',
    'Government',
    'Regimental or Corps charity',
];

export const serviceTypes = ['Army', 'Navy', 'Marines', 'Air Force'];

export const serviceSubTypes = ['Regular', 'Reservist'];

export const serviceStages = [
    'Serving',
    'Service Leaver',
    'Veteran',
    'Family, spouse or partner of serving',
    'Family, spouse or partner of veteran',
];

export const questionTypes = [
    'Checklist',
    'Currency',
    'Date',
    'Multi-Select',
    'Multiple-Choice',
    'Number',
    'Text',
    'Yes/No',
    'Information',
];

export const subCategoryQuestionSubTypes = ['sub-category', 'pathway'];

export const ranks = ['All', 'Officer'];

export const immigrationTypes = ['All', 'UK Citizen', 'Right to Remain', 'None'];

export const benefitTypes = ['Anyone', 'On Benefits', 'Not on Benefits'];

export const employmentTypes = ['All', 'Unemployed', 'Employed'];

export const criminalJusticeSystemTypes = ['All', 'Yes in CJS', 'Not in CJS'];

export const DEFAULT_OPENING_HOURS = [
    {
        day: 'Monday',
        from_time: '08:00',
        to_time: '17:00',
    },
    {
        day: 'Tuesday',
        from_time: '08:00',
        to_time: '17:00',
    },
    {
        day: 'Wednesday',
        from_time: '08:00',
        to_time: '17:00',
    },
    {
        day: 'Thursday',
        from_time: '08:00',
        to_time: '17:00',
    },
    {
        day: 'Friday',
        from_time: '08:00',
        to_time: '17:00',
    },
    {
        day: 'Saturday',
        from_time: '08:00',
        to_time: '17:00',
        is_closed: true,
    },
    {
        day: 'Sunday',
        from_time: '08:00',
        to_time: '17:00',
        is_closed: true,
    },
];

export const thresholds = [
    'Less than',
    'Greater than',
    'Equal to',
    'Less than or equal to',
    'Greater than or equal to',
];

export const DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

export const utilityBills = [
    'Electricity',
    'Water',
    'Internet',
    'Cable/Satellite TV',
    'Landline Phone',
];

export const validIds = [
    'Passport',
    "Driver's License",
    'National Identity Card',
    'MOD90 (Military ID Card)',
    'Veterans ID card',
    'Veterans Rail Card',
];

export const MAX_VOICE_RECORDING = process.env.REACT_APP_MAX_VOICE_RECORDING;

export const groupServingTypes = ['Serving', 'Veteran', 'Family'];

export const PUBLIC_PATHS = [
    '/login',
    '/identity/status',
    '/forgot-password',
    '/family-groups/groups',
    '/registration/user',
    '/identity/activation-code',
    '/registration/code',
    '/create-user',
    '/create-password',
    '/colleges',
    '/subjects',
    '/admin/services',
    '/groups/parent-regiments',
    '/identity/regiments',
    '/identity/update-my-profile',
    '/on-boarding/update-profile',
    '/device',
    '/identity/terms-and-conditions',
    '/industry-list',
    '/logs',
    '/token/refresh-token-from-client-id',
    '/token/refresh-token',
    '/public/events',
    '/events/[id]',
    '/events/[id]/going',
    '/events/reply/[id]',
    '/events/is-user',
    '/events/captcha',
    '/public/fundraising/[id]',
    '/public/fundraising/[id]/donate',
    '/public/fundraising/[id]/payment-intent',
    '/public/fundraising/[id]/donate/pledge',
    '/public/currencies',
    '/public/crews/[id]',
    '/admin/dynalink',
    '/public-embed/embed-code',
    '/db/event-answer-types',
    '/db/event-types',
    '/db/categories',
    '/db/article-types',
    '/elastic/webhook',
    '/image_to_base64',
    '/admin/welfare-upload-mp3',
    'public/welfare-service/introduction',
    'public/welfare-service/groups',
    'public/welfare-service/sub-categories',
    'public/welfare-service/sub-category/[id]',
    'public/welfare-service/categories',
    'public/welfare-service/identity/[id]/[id]',
    'public/welfare-service/identity/[id]/[id]/welfare-support-pdf',
    'public/welfare-service/identity/[id]/[id]/welfare-support-proof-of-service',
    'public/welfare-service/identity/[id]/[id]/welfare-support-checklist',
    'public/welfare-service/question/[id]',
    'public/welfare-service/providers',
    'public/welfare-service/providers/checklist',
    'public/welfare-service/primary-group-contacts',
    'public/welfare-service/primary-group-contact/[id]',
    'public/welfare-service/primary-groups',
    'public/welfare-service/parent-categories',
    'public/welfare-service/group-servings',
    'public/welfare-service/group-serving/[id]',
    'public/welfare-service/group-questions',
    'public/[id]/welfare-service/members',
    'public/[id]/welfare-service/member-answer/complete',
    'public/welfare-service/group-question/[id]',
    'public/welfare-service/emergency-supports',
    'public/welfare-service/emergency-support/[id]',
    'public/welfare-service/cost-of-livings',
    'public/welfare-service/cost-of-living/[id]',
    'public/[id]/[id]/welfare-service/member-answer/add',
    'public/[id]/[id]/welfare-service/member-answer/[id]',
    'public/[id]/[id]/welfare-service/member-answer/[id]/summary-pdf',
    'public/[id]/welfare-service/case/[id]',
    '/admin/registration-group-list',
    'public/[id]/welfare-service/member-answers/[id]',
    'public/[id]/[id]/welfare-service/feedback',
];

export const FEEDBACK_STATUS_OPTIONS: Array<{ value: FeedbackStatus; label: string }> = [
    { value: 'new', label: 'New' },
    { value: 'in_progress', label: 'In Progress' },
    { value: 'complete', label: 'Complete' },
];

export const FEEDBACK_SUBMITTER_TYPE_OPTIONS: Array<{ value: FeedbackSubmitterType; label: string }> = [
    { value: 'admin', label: 'Admin' },
    { value: 'beneficiary', label: 'Beneficiary' },
];

export const FEEDBACK_MAX_LENGTH = {
    NAME: 200,
    EMAIL: 254,
    COMMENT: 10000,
};

export const FEEDBACK_LIST_MAX_LIMIT = 100;
